<!--
  功能：功能描述
  作者：missfox
  邮箱：missfoxw@163.com
  时间：2021年09月24日 14:44:01
  版本：v1.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
    <div class="history">
      <div  :class="['header',isApp?'no-header':'']">
        <filterBtn @click="openFilter(true)"></filterBtn>
        <!-- <el-date-picker
            v-model="times"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="timestamp"
            popper-class="date-picker">
        </el-date-picker> -->
        <div class="time-container" @click="show=true">{{dateStr?dateStr:'选择日期'}}</div>
        <van-calendar v-model="show" type="range" allow-same-day :default-date="getDefaultDate()" :min-date="getMinDate()" @confirm="onConfirm" />
      </div>
      <div class="list">
        <template v-if="implementList&&implementList.length">
          <div class="block" v-for="(item,index) in implementList" :key="index">
            <implementItemHeader :name="item.ProfileName" :avatar="item.ImgUrl" :time="item.newDTime" :room="item.RoomNo"></implementItemHeader>
            <div class="line"></div>
            <implementItemFooter :showType="1" :obj="item" :task="item.Message" :status="item.Status" :oldStatus="item.oldStatus" :InputDate="item.newInputDate" :Value="item.Value" :remark="item.Remark" :userName="item.CUser"
            ></implementItemFooter>
          </div>
        </template>
        <tips v-else></tips>
      </div>
      <pager @changePage="changePage" @changeSize="changeSize" :page='page+1' :total="total" :size="size"></pager>
    </div>
</template>

<script>
import filterBtn from '@/common/filter-btn.vue'
import pager from '@/common/pager.vue'
import implementItemHeader from '@/common/implement-item-header.vue'
import implementItemFooter from '@/common/implement-item-footer.vue'
import tips from '@/common/tips.vue'
import {group,timeCompared,formatDate} from '@/tool'
import { mapState ,mapActions } from 'vuex'
import filter from '../../store/modules/filter'


export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    filterBtn,
    pager,
    implementItemFooter,
    implementItemHeader,
    tips
  },
  // 组件状态值
  data () {
   return {
      times:null,
      isApp:true,
      size:10,
      page:0,
      total:10,
      show:false,
      dateStr:''

    }
  },
  // 计算属性
  computed: {
    ...mapState(['ElderlyCares','Items','NurseSignatureViews','saveVal']),
    ...mapState('filter',['selectDetails','selectRooms','activeShifts']),

    implementHistory(){
        let ItemsArr=this.NurseSignatureViews.filter(item=>{
            //项目执行时间
            let time=item.Time
            //项目执行录入时间（实际完成时间）
            item.timestamp=new Date(item.InputDate).getTime()
            item.newDTime=`${item.CDate.split('T')[0]} ${item.Time}`
            item.newInputDate=item.InputDate.substr(0,item.InputDate.length-3)
            return item.Status!==null&&
            (!this.selectDetails.length||this.selectDetails.indexOf(item.Message)!=-1)&&
            (!this.activeShifts.length||this.activeShifts.indexOf(timeCompared(time,filter.state.shiftTimeList,filter.state.shifts))!=-1)&&
            (!this.selectRooms.length||this.selectRooms.indexOf(item.RoomNo)!=-1)&&
            (!this.times||(this.times[0]<=item.timestamp&&item.timestamp<this.times[1]))
        })
        this.total=ItemsArr.length
        if(this.page*this.size>=this.total){
            this.page=0
        }
        return ItemsArr
    },
    implementHistoryArr(){
        let ItemsArr=group(this.implementHistory,this.size)
        return ItemsArr||[[]]
    },
    implementList(){
      return this.implementHistoryArr[this.page]
    },
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    ...mapActions('filter', ['openFilter']),
    changePage(page){
      this.page=page
    },
    changeSize(size){
      this.size=size
    },
    getMinDate(){
      const date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * 5);
      return date
    },
    getDefaultDate(){
      let nowDate=new Date()
      return [new Date(formatDate(nowDate)),new Date(formatDate(nowDate))]
    },

    onConfirm(times){
      const [start, end] = times;
      this.dateStr = `${formatDate(start,'/')} - ${formatDate(end,'/')}`;
      times[0]=start.getTime()
      times[1]=end.getTime()+24*60*60*1000
      this.times=times
      this.show=false
    }
  },
  /**
  * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
  */
  created () {
    this.isApp= localStorage.getItem('isApp') === '0'
  },

}
</script>

<style scoped>
.history{
  padding-bottom: 30px;
}
.history >>> .el-date-editor{
  border: none;
}
.header{
  position: fixed;
  top: 94px;
  left: 0px;
  width: 100%;
  box-sizing: border-box;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #fff;
}
.no-header {
  top: 48px !important;
}

.header >>> .el-date-editor{
  width: 274px;
  height: 35px;
  background: #F4F4F4;
}
.header >>> .el-date-editor .el-range__icon{
  font-size: 16px;
  line-height: 33px;
  width: 25px;
  border: none;
}
.header >>> .el-date-editor .el-range-separator{
  line-height: 31px;
  font-size: 12px;
}
.header >>> .el-range-input{
  font-size: 12px;
  background: #F4F4F4;
}
.header >>> .el-icon-time+.el-range-input{
  text-align: left
}
.header >>> .el-range-input{
  text-align: right;
}
.header >>> .el-range-separator{
  color: #C7C9CC;
}
.list{
  padding: 115px 15px 0px 15px;
}
.block{
  background: #fff;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 4px;
}
.line{
  width: 100%;
  height: 1px;
  background: #EBEBEB;
  margin-bottom: 12px;
}
.time-container{
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/components/nursing/history.vue